module.exports = __webpack_public_path__ + "media/images/trailmaker/create-release-52d011e9b373374dc7c6c9dd6e6c5a38.svg";